import { useHistory } from "react-router-dom";
import axios from "axios"; // Import Axios

import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Link,
  Modal,
  Tooltip,
  Typography,
  TextField,
} from "@mui/material";
import {
  usePagination,
  useQuery,
  useResultsPerPage,
  useSearchContext,
} from "@sajari/react-hooks";
import { Loader } from "components/wrapper/fullPageLoader";
import { useContext, useEffect, useRef, useState } from "react";
import { titelize } from "utils/titelize";
import { getSinglePrice } from "../../Product/displayPrice";
import useLazyLoad from "./useLazyLoad";
import clsx from "clsx";
import { LoadingPosts } from "./loadingPosts";
import ShareIcon from "@mui/icons-material/Share";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { RootState } from "redux/store";
import { useDispatch, useSelector } from "react-redux";
import snack from "components/wrapper/snack";
import { addToWishListStart, removeFromWishListStart } from "redux/wishlist";
import { useInfiniteHits } from "react-instantsearch-hooks-web";
import { CopyToClipboard } from "react-copy-to-clipboard";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import {
  FacebookShareButton,
  WhatsappShareButton,
  EmailShareButton,
  RedditShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  LinkedinIcon,
  EmailIcon,
  RedditIcon,
  TwitterIcon,
  WhatsappIcon,
  FacebookIcon,
} from "react-share";
import { formattedData } from "utils/formatData";
import useWindowSize from "utils/useWindowSize";
import styled from "styled-components";
import sendEventAndConversion from "api/algoliaTracker";

const Title = styled.p`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
`;

export default function ProductList() {
  // console.log(results, "Product list hit resuly check here");
  const [results, setHitResultsData] = useState<any>();
  const history = useHistory();
  const [resultItems, setResultItems] = useState([]);
  const [displayProducts, setDisplayProducts] = useState([]);
  const [shareModelOpen, setShareModelOpen] = useState(false);
  const [shareProductDetails, setShareProductDetails] = useState({
    id: "",
    title: "",
  });
  const [userToken, setUserToken] = useState(null);
  const { hits, showMore, isLastPage, sendEvent } = useInfiniteHits();
  const [pageNumber, setPageNumber] = useState(1);
  const { totalResults }: any = useSearchContext();
  const triggerRef: any = useRef(null);
  const { query, setQuery } = useQuery();
  const { resultsPerPage, setResultsPerPage } = useResultsPerPage();
  const [resetDataSet, setResetDataSet] = useState(false);
  const { setPage } = usePagination();
  const wishlist = useSelector((state: RootState) => state.wishlist.wishList);
  const accessToken: any = useSelector(
    (state: RootState) => state.user.accessToken
  );
  const dispatch = useDispatch();
  const size = useWindowSize();
  const shareUrl = `${window.location.origin}/product-page/${
    shareProductDetails.id
  }/${titelize(shareProductDetails.title)}`;

  useEffect(() => {
    // alert("called");
    setHitResultsData(formattedData(hits));
    //Need to do changes here!!!!
    // console.log(hitResultsData, "Hit Results Data check here");
  }, [hits]);
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (sentinelRef.current !== null) {
      const observer: any = new IntersectionObserver((entries) => {
        entries.forEach((entry: any) => {
          if (entry.isIntersecting && !isLastPage) {
            showMore();
          }
        });
      });

      observer.observe(sentinelRef?.current);

      return () => {
        observer.disconnect();
      };
    }
  }, [isLastPage, showMore]);
  useEffect(() => {
    if (results) {
      if (results.length) {
        let _resultItems = results.filter(
          (i: any) =>
            i.values.productgroupimageurl1 !==
            "https://storage.googleapis.com/content.paysfer.com/uploads/paysfer-placeholder.png"
        );
        // resultItems prev is similar to current
        let inStock: any = [];
        let notInStock: any = [];
        _resultItems.forEach((element: any) => {
          if (
            element.values.Quantity === undefined ||
            element.values.Quantity[0] === undefined ||
            element.values.Quantity[0] === "0" ||
            element.values.Quantity[0] <= 0
          ) {
            notInStock.push(element);
          } else {
            inStock.push(element);
          }
        });
        let sortedResults = [...inStock, ...notInStock];
        setResultItems(sortedResults as any);
      }
    }
  }, [results]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleClick = (item: any) => {
    const data = {
      eventName: "product_click",
      index: "paysfer",
      objectIDs: [item.values.objectID],
      queryID: item.values.__queryID,
      positions: [item.values.__position],
    };

    sendEventAndConversion(data);
    //axios.post("http://localhost:4000/api/v1/algolia/track", data);

    // aa("clickedObjectIDsAfterSearch", {
    //   eventName: "product_click",
    //   index: "paysfer",
    //   objectIDs: [item.values.objectID], // Assuming item.values.objectID is the correct property
    //   queryID: item.values.__queryID,
    //   positions: [item.values.__position],
    // });

    // Extract item values
    const { id, title } = item.values;
    const formattedTitle = titelize(title);

    // Construct the URL with query parameters
    const url = new URL(
      `/product-page/${id}/${formattedTitle}`,
      window.location.origin
    );
    url.searchParams.set("src", "from-search");

    // Open the new URL in a new tab
    window.open(url.toString(), "_blank");
  };

  const handleAddToWishList = (item: any) => {
    if (!accessToken) {
      snack.error("Please Sign in to Continue");
      return;
    } else {
      const _product: any = {};
      _product.productId = item.values.id;
      _product.name = item.values.title;
      _product.price = Number(
        item.values.saleprice ? item.values.saleprice[0] : item.values.price[0]
      );
      _product.type = "wishlist";
      _product.total = Number(
        item.values.saleprice ? item.values.saleprice[0] : item.values.price[0]
      );
      _product.productSellerSKU = item.values.SellerSKU[0];

      dispatch(addToWishListStart(_product));
      snack.success("Item added to Wishlist");
    }
  };

  const handleRemoveToWishList = (item: any) => {
    for (let i = 0; i < wishlist.length; i++) {
      if (wishlist[i]["_id"] === item.values.id) {
        dispatch(removeFromWishListStart(wishlist[i]["wishlistId"]));
        snack.error("Item removed from Wishlist");
      }
    }
  };

  const SingleProductLayout = (item: any, index: number) => {
    let isWishlist = false;
    wishlist.forEach((ele) => {
      if (ele["_id"] === item.values["id"]) {
        isWishlist = true;
      }
    });
    return (
      <div
        key={item.toString()}
        className={size.x > 1000 ? "col-md-4 col-lg-3" : ""}
        style={size.x > 1000 ? { marginBottom: "24px" } : {}}
      >
        {size.x < 1000 ? (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                cursor: "pointer", // optional: show it's clickable
              }}
              onClick={() => handleClick(item)}
            >
              <CardMedia
                image={item.values.productgroupimageurl1}
                title={item.values.title}
                sx={{ width: 200 }}
              />
              <CardContent>
                <Typography
                  style={{ fontWeight: 600 }}
                  gutterBottom
                  component="div"
                >
                  {item.values.title}
                </Typography>
                <Typography
                  gutterBottom
                  component="div"
                  style={{ color: "#6a926a" }}
                >
                  ${getSinglePrice(item?.values)}&#160;&#160;
                  {item.values.Quantity === undefined ||
                  item.values.Quantity[0] === undefined ||
                  item.values.Quantity[0] === "0" ||
                  item.values.Quantity[0] <= 0
                    ? "Out of Stock"
                    : "Available in Stock"}
                </Typography>
              </CardContent>
              <CardActions>
                <div
                  style={{
                    padding: "0px 8px",
                    border: "0px 1px 1px 1px solid black",
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                    gap: "1em",
                  }}
                >
                  {isWishlist ? (
                    <FavoriteIcon
                      style={{ width: "18px", color: "#EF5051" }}
                      onClick={(e) => {
                        e.stopPropagation(); // 👈 prevents Box onClick from firing
                        handleRemoveToWishList(item);
                      }}
                    />
                  ) : (
                    <FavoriteBorderOutlinedIcon
                      style={{ width: "18px", color: "#EF5051" }}
                      onClick={(e) => {
                        e.stopPropagation(); // 👈 prevents Box onClick from firing
                        handleAddToWishList(item);
                      }}
                      sx={{
                        opacity: 0.6,
                        "&:hover": {
                          opacity: 1,
                        },
                      }}
                    />
                  )}
                  &nbsp;&nbsp;
                  <ShareIcon
                    style={{ width: "18px", color: "#EF5051" }}
                    sx={{
                      opacity: 0.6,
                      "&:hover": {
                        opacity: 1,
                      },
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // 👈 prevents Box onClick from firing
                      setShareProductDetails({
                        id: item.values["id"],
                        title: item.values.title,
                      });
                      setShareModelOpen(true);
                    }}
                  />
                </div>
              </CardActions>
            </Box>

            <hr />
          </>
        ) : (
          <Card
            onClick={() => handleClick(item)}
            sx={{
              boxShadow: "none",
              maxWidth: 345,
              borderRadius: "10px",
              transition: "0.2s",
              "&:hover": {
                boxShadow: "#ddd 0px 5px 7px 2px",
                cursor: "pointer",
                transform: "scale(1.04)",
                transition: "0.2s",
              },
            }}
          >
            <CardMedia
              sx={{ height: 250 }}
              image={item.values.productgroupimageurl1}
              title={item.values.title}
              onClick={() => handleClick(item)}
            />
            <CardContent style={{ height: "160px", fontSize: "15px" }}>
              <Typography
                onClick={() => handleClick(item)}
                style={{ fontWeight: 400 }}
                gutterBottom
                component="div"
              >
                <Title>{item.values.title}</Title>
              </Typography>

              <Typography
                gutterBottom
                component="div"
                style={{ color: "#6a926a" }}
              >
                ${getSinglePrice(item?.values)}&#160;&#160;
                {item?.values?.SellerId?.toString() !==
                  "0592de2a-815c-4929-a521-82301b246cce" &&
                  (item.values.Quantity === undefined ||
                  item.values.Quantity[0] === undefined ||
                  item.values.Quantity[0] === "0" ||
                  item.values.Quantity[0] <= 0 ? (
                    <span>Out of Stock</span>
                  ) : (
                    <span>Available in Stock</span>
                  ))}
              </Typography>

              {/* <Typography variant="body2" color="text.secondary">
                Free shipping
                <br />
                Free returns
              </Typography> */}
            </CardContent>
            <CardActions>
              <div
                style={{
                  padding: "0px 8px",
                  border: "0px 1px 1px 1px solid black",
                }}
              >
                {isWishlist ? (
                  <FavoriteIcon
                    style={{ width: "18px", color: "#EF5051" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveToWishList(item);
                    }}
                  />
                ) : (
                  <FavoriteBorderOutlinedIcon
                    style={{ width: "18px", color: "#EF5051" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleAddToWishList(item);
                    }}
                    sx={{
                      opacity: 0.6,
                      "&:hover": {
                        opacity: 1,
                      },
                    }}
                  />
                )}
                &nbsp;&nbsp;
                <ShareIcon
                  style={{ width: "18px", color: "#EF5051" }}
                  sx={{
                    opacity: 0.6,
                    "&:hover": {
                      opacity: 1,
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShareProductDetails({
                      id: item.values["id"],
                      title: item.values.title,
                    });
                    setShareModelOpen(true);
                  }}
                />
              </div>
            </CardActions>
          </Card>
        )}
        {/* old design */}
        {/* <div className="exclusive-product-card">
          <Link onClick={() => handleClick(item)}>
            <div className="exclusive-product-img">
              <img
                alt='"exclusive-product-img"'
                src={item.values.productgroupimageurl1}
              />
            </div>
          </Link>
          <div
            style={{
              padding: "0px 8px",
              border: "0px 1px 1px 1px solid black",
            }}
          >
            {isWishlist ? (
              <FavoriteIcon
                style={{ width: "18px", color: "#EF5051" }}
                onClick={() => handleRemoveToWishList(item)}
              />
            ) : (
              <FavoriteBorderOutlinedIcon
                style={{ width: "18px", color: "#EF5051" }}
                onClick={() => handleAddToWishList(item)}
                sx={{
                  opacity: 0.6,
                  "&:hover": {
                    opacity: 1,
                  },
                }}
              />
            )}

            <ShareIcon
              style={{ width: "18px", color: "#EF5051", float: "right" }}
              sx={{
                opacity: 0.6,
                "&:hover": {
                  opacity: 1,
                },
              }}
              onClick={() => {
                setShareProductDetails({id:item.values["id"],title:item.values.title})
                setShareModelOpen(true)

              }}
            />
          </div>
          <div className="exclusive-product-details">
            <div className="exclusive-product-content">
              <div className="exclusive-product-name">
                <Link onClick={() => handleClick(item)}>
                  {item.values.title}
                </Link>
              </div>
              <div className="exclusive-product-name">
                <Link href={item.values.productgroupimageurl1}>
                  {item.values.ratingCount}
                </Link>
              </div>
              <div className="d-flex">
                <div className="new-price yellow-color">
                  ${getSinglePrice(item?.values)}&#160;&#160;
                  {item.values.Quantity === undefined ||
                  item.values.Quantity[0] === undefined ||
                  item.values.Quantity[0] === "0" ||
                  item.values.Quantity[0] <= 0
                    ? "Out of Stock"
                    : "Available in Stock"}
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    );
  };

  const onGrabData = async (currentPage: number) => {
    // setPage(currentPage);
    showMore();
    return new Promise((resolve) => {
      const data = formattedData(hits);
      setResetDataSet(false);
      resolve(data);
    });
  };
  useEffect(() => {
    setResultsPerPage(Number(100));
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    setResetDataSet(true);
  }, [totalResults]);

  // const { updatedData, loading } = useLazyLoad({
  //   triggerRef,
  //   onGrabData,
  //   resetDataSet,
  // });

  return (
    <>
      <div className={size.x < 1000 ? "column" : "row"}>
        {results?.length > 0 &&
          results.map((item: any, index: number) =>
            SingleProductLayout(item, index)
          )}
      </div>
      <div
        ref={sentinelRef}
        style={{ display: results && results.length === 0 ? "none" : "block" }}
        className={clsx("trigger", { visible: false })}
      >
        <div className="row">
          <LoadingPosts />
        </div>
      </div>
      <Modal
        open={shareModelOpen}
        onClose={() => {
          setShareModelOpen(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            borderRadius: "5px",
            boxShadow: "24",
            p: 4,
            height: 240,
            background: "white",
            justifyContent: "center",
            alignItems: "center",
            "@media (max-width: 1000px)": {
              width: "80vw", // Adjust width for smaller screens
              height: "40vh", // Make the height auto to fit content
            },
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h3">
            Share this listing
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-evenly",
              padding: "0.4rem",
              alignSelf: "stretch",
            }}
          >
            <p
              style={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              Click on this icon to copy below link
            </p>
            <CopyToClipboard
              text={`${window.location.origin}/product-page/${
                shareProductDetails.id
              }/${titelize(shareProductDetails.title)}`}
              onCopy={() => {
                snack.success("Link copied to clipboard!");
              }}
            >
              <Tooltip title="Copy Below link" style={{ marginRight: "5em" }}>
                <InsertLinkIcon
                  sx={{
                    opacity: 1,
                    cursor: "pointer",
                    transition: "1s",
                    stroke: "black",
                    strokeWidth: 1,
                    "&:hover": {
                      opacity: 1,
                      transform: "scale(1.05)",
                      transition: "1s",
                    },
                  }}
                />
              </Tooltip>
            </CopyToClipboard>
          </Box>
          <Box
            sx={{
              width: 500,
              maxWidth: "100%",
            }}
          >
            <CopyToClipboard
              text={`${window.location.origin}/product-page/${
                shareProductDetails.id
              }/${titelize(shareProductDetails.title)}`}
              onCopy={() => {
                snack.success("Link copied to clipboard!");
              }}
            >
              <TextField
                fullWidth
                label="Link"
                sx={{ input: { cursor: "pointer" } }}
                InputProps={{
                  style: {
                    borderRadius: "10px",
                  },
                }}
                disabled={true}
                defaultValue={shareUrl}
              />
            </CopyToClipboard>
          </Box>
          <div
            style={{
              background: "#0000",
              height: "100vh",
              width: "100%",
              display: "flex",
              gap: "0.5em",
              justifyContent: "center",
              marginTop: "1em",
            }}
          >
            <FacebookShareButton url={shareUrl}>
              <FacebookIcon size={40} round={true} />
            </FacebookShareButton>

            <WhatsappShareButton url={shareUrl}>
              <WhatsappIcon size={40} round={true} />
            </WhatsappShareButton>

            <EmailShareButton url={shareUrl}>
              <EmailIcon size={40} round={true} />
            </EmailShareButton>

            <RedditShareButton url={shareUrl}>
              <RedditIcon size={40} round={true} />
            </RedditShareButton>
            <TwitterShareButton url={shareUrl}>
              <TwitterIcon size={40} round={true} />
            </TwitterShareButton>
            <LinkedinShareButton url={shareUrl}>
              <LinkedinIcon size={40} round={true} />
            </LinkedinShareButton>
          </div>
        </Box>
      </Modal>
    </>
  );
}
